if (!customElements.get('floating-cart')) {
  customElements.define(
    'floating-cart',
    class FloatingCart extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        this.count = this.querySelector('.ws-floating-cart__count');
        this.countLabel = this.querySelector('[data-cart-count-label]');
        this.translations = JSON.parse(this.querySelector('[data-cart-count-translations]').textContent);
        this.revision = 0;
        this.onPageShow = () => this.refresh();
        this.onVisibilityChange = () => {
          if (document.visibilityState === 'visible') this.refresh();
        };
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData, source }) => {
          const animate = source === 'product-form';
          if (Number.isInteger(cartData?.item_count)) {
            this.revision += 1;
            this.render(cartData.item_count, animate);
            return;
          }
          return this.refresh(animate);
        });
        window.addEventListener('pageshow', this.onPageShow);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
      }

      disconnectedCallback() {
        this.unsubscribe();
        window.removeEventListener('pageshow', this.onPageShow);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.revision += 1;
        this.animation?.cancel();
      }

      async refresh(animate = false) {
        const revision = ++this.revision;
        try {
          const response = await fetch(`${routes.cart_url}.js`, {
            headers: { Accept: 'application/json' },
            cache: 'no-store',
          });
          if (!response.ok) throw new Error(`Cart request failed (${response.status})`);
          const cart = await response.json();
          if (!Number.isInteger(cart.item_count) || cart.item_count < 0) {
            throw new Error('Cart response has an invalid item count');
          }
          if (this.isConnected && revision === this.revision) this.render(cart.item_count, animate);
        } catch (error) {
          console.error('Unable to refresh floating cart:', error);
        }
      }

      render(count, animate = false) {
        const previousCount = Number(this.count.textContent);
        this.count.textContent = count;
        this.countLabel.textContent = (count === 1 ? this.translations.one : this.translations.other).replace(
          '[count]',
          count
        );
        this.link.hidden = count === 0;
        if (count === 0) this.animation?.cancel();
        if (animate && count > previousCount && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.animation?.cancel();
          this.animation = this.link.animate(
            [
              { transform: 'translateY(0) scale(1)' },
              { transform: 'translateY(-8px) scale(1.04)', offset: 0.4 },
              { transform: 'translateY(0) scale(1)' },
            ],
            { duration: 450, easing: 'ease-out' }
          );
        }
      }
    }
  );
}
